import {ArticleAiInAction} from "@/pages/common/Home/Dissection/Articles/ArticleAiInAction";
import {ArticleBeyondReach} from "@/pages/common/Home/Dissection/Articles/ArticleBeyondReach";
import {ArticleTopPriority} from "@/pages/common/Home/Dissection/Articles/ArticleTopPriority";
import {EvolvingRole} from "@/pages/common/Home/Dissection/Articles/EvolvingRole";

import React, {forwardRef} from "react";

import {capitalize} from "@helpers";
import article_1 from "@images/home/analytics/ai_in_action/article-1.png";
import article_4 from "@images/home/analytics/beyond_reach/article-4.png";
import clock from "@images/home/analytics/clock.png";
import article_3 from "@images/home/analytics/evolving_role/article-3.png";
import article_2 from "@images/home/analytics/top_priority/article-2.png";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {motion} from "framer-motion";
import moment from "moment";
import {useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const ARTICLES = [
  {
    id: 0,
    image: article_1,
    date: new Date("2025-01-21"),
    time: 10,
    title: (
      <>
        AI&nbsp;in&nbsp;Action: Driving Sales Force Performance and
        Effectiveness
      </>
    ),
    desc: (
      <>
        Struggling with MR&nbsp;engagement and product messaging? COSMART AVA is
        the AI-powered training simulator transforming how pharmaceutical sales
        teams connect with HCPs. Designed to&nbsp;sharpen objection-handling,
        enhance communication, and drive sales effectiveness, read
        on&nbsp;to&nbsp;see more on&nbsp;how AVA equips MRs with the skills they
        need to&nbsp;thrive in high-pressure environments. Backed
        by&nbsp;impressive results (60% improvement in&nbsp;product knowledge
        and 65% stronger communication skills) AVA is&nbsp;redefining commercial
        excellence.
      </>
    ),
    body: <ArticleAiInAction />,
  },
  {
    id: 1,
    image: article_2,
    date: new Date("2025-04-28"),
    time: 8,
    title: (
      <>
        The Top Priority for Sales Leaders: Improving Sales Enablement and
        Training in&nbsp;Pharma&nbsp;&mdash; with AVA
      </>
    ),
    desc: (
      <>
        Struggling pharma sales teams face 84% quota misses and 11.2-month
        onboarding. AVA, an&nbsp;AI-driven tool, is&nbsp;changing the game
        by&nbsp;speeding ramp times and empowering sales reps. Want
        to&nbsp;unlock your sales team&rsquo;s potential? Click to&nbsp;read
        more.
      </>
    ),
    body: <ArticleTopPriority />,
  },
  {
    id: 2,
    image: article_3,
    date: new Date("2025-02-24"),
    time: 11,
    title: (
      <>
        The Evolving Role of&nbsp;AI&nbsp;in&nbsp;Drug Submission and Approval:
        An&nbsp;Expert Perspective
      </>
    ),
    desc: (
      <>
        Artificial intelligence (AI) is&nbsp;transforming the pharmaceutical
        industry, revolutionising drug discovery and approval processes and
        reshaping how researchers identify potential drug candidates, streamline
        clinical trials, and ensure regulatory compliance.
      </>
    ),
    body: <EvolvingRole />,
  },
  {
    id: 3,
    image: article_4,
    date: new Date("2026-02-27"),
    time: 11,
    title: (
      <>
        Beyond Reach: Enabling the&nbsp;New&nbsp;Era of&nbsp;Digital-First
        Pharma
      </>
    ),
    desc: (
      <>
        Gen Alpha is&nbsp;the&nbsp;first generation born into a&nbsp;world
        where&nbsp;AI isn't new&nbsp;- it’s native. For&nbsp;pharma,
        this&nbsp;means that the&nbsp;people we hire
        and&nbsp;the&nbsp;professionals we serve are&nbsp;changing.
        Dramatically. And&nbsp;permanently.
      </>
    ),
    body: <ArticleBeyondReach />,
  },
];

const itemAnimation = {
  hidden: {y: 150, opacity: 0},
  visible: (custom) => ({
    y: 0,
    opacity: 1,
    transition: {
      delay: custom * 0.4,
    },
  }),
};

const ArticleCard = forwardRef((props, ref) => {
  const {id, image, date, time, title, desc} = props;

  const navigate = useNavigate();

  const handleClickArticle = (props) => {
    const formattedTitle = props?.title?.props?.children
      .replace(/[^a-zA-Zа-яА-ЯёЁ0-9\s]/g, "")
      .replace(/\s+/g, "_")
      .toLowerCase();

    navigate(`/home/article/${props.id}/${formattedTitle}`);
  };

  return (
    <li
      key={id}
      ref={ref}
      onClick={() => handleClickArticle(props)}
    >
      <BorderArticle>
        <div className={styles.article_card}>
          <img
            src={image}
            alt={"article-preview"}
          />

          <div className={styles.article_desc}>
            <div className={styles.article_desc_head}>
              <span>{capitalize(moment(date).format("DD MMMM YYYY"))}</span>

              <div>
                <img
                  src={clock}
                  alt={"clock"}
                />

                <p>{time} MIN</p>
              </div>
            </div>

            <h3>{title}</h3>

            <div className={styles.article_desc_subtitle}>
              <RootDesc>
                <span>{desc}</span>
              </RootDesc>
            </div>
          </div>
        </div>
      </BorderArticle>
    </li>
  );
});

export const MArticleCard = motion(ArticleCard);

export const Articles = () => {
  const sortedArticles = [...ARTICLES].sort((a, b) => a.date - b.date);

  return (
    <motion.ul
      initial={"hidden"}
      whileInView={"visible"}
      viewport={{amount: 0, once: true}}
      className={styles.articles_wrapper}
    >
      {sortedArticles &&
        sortedArticles.length > 0 &&
        sortedArticles.map(
          (item, index) =>
            item.body && (
              <React.Fragment key={item.id}>
                <MArticleCard
                  custom={sortedArticles.length - index}
                  variants={itemAnimation}
                  {...item}
                />
              </React.Fragment>
            ),
        )}
    </motion.ul>
  );
};
